import React from "react";
import { Container, Table, Pagination } from "semantic-ui-react";
import _ from "lodash";
import * as HostTableColumns from "components/Admin/Hosts/HostTableColumns";
import { PendingRow } from "components/Admin/PendingRow";
import { PAGE_SIZE } from "env.config";
import { useRef } from "react";

const HostRow = ({ host, columns, onSelect, isSelected, activeStatus }) => {
  return (
    <Table.Row active={isSelected} onClick={() => onSelect && onSelect(host)}>
      {columns.map(({ render }, index) => (
        <Table.Cell key={index}>{render(host, activeStatus)}&nbsp;</Table.Cell>
      ))}
    </Table.Row>
  );
};

const HostHeaderRow = ({ columns, hostWidth }) => {
  const trRef = useRef(null);
  React.useEffect(() => {
    const width = getComputedStyle(document.querySelector(".ui.table")).width;
    trRef.current = width.slice(0, -2);
  }, []);
  columns[0].style = { width: hostWidth <= 40 ? "300px" : hostWidth + "px" };
  return (
    <Table.Row>
      {columns.map(({ title, style }, index) => (
        <Table.HeaderCell key={index} style={style}>
          {title}&nbsp;
        </Table.HeaderCell>
      ))}
    </Table.Row>
  );
};

const HostTable = ({
  renderList,
  onPageChange,
  onSelectHost,
  selectedItem,
  listInfo,
  activeStatus,
}) => {
  const columns = [
    HostTableColumns.Host,
    HostTableColumns.Envide,
    HostTableColumns.Active,
    HostTableColumns.Scope,
    HostTableColumns.Stage,
    HostTableColumns.Name,
  ];
  const getMaxWidthOfHost = (renderList) => {
    const strings = renderList.map((item) => item.Host).slice(0, 10);
    let longestString = "";

    for (let i = 0; i < strings.length; i++) {
      const currentString = strings[i];

      if (currentString.length > longestString.length) {
        longestString = currentString;
      }
    }
    const length = longestString.length * 7 + 40;
    return length;
  };

  const tableRows = _.range(PAGE_SIZE).map((index) => {
    const host = renderList[index] || {};
    if (!listInfo.loaded) {
      return <PendingRow columnCount={6} key={index} />;
    }
    return (
      <HostRow
        host={host}
        columns={columns}
        key={index}
        isSelected={
          selectedItem &&
          selectedItem.HostId &&
          host.HostId === selectedItem.HostId
        }
        onSelect={onSelectHost}
        activeStatus={activeStatus}
      />
    );
  });
  const hostWidth = getMaxWidthOfHost(renderList);
  return (
    <Table className="ui celled table">
      <Table.Header>
        <HostHeaderRow columns={columns} hostWidth={hostWidth} />
      </Table.Header>
      <Table.Body>{tableRows}</Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell colSpan={6}>
            <Container fluid textAlign="right">
              <Pagination
                activePage={listInfo.activePage + 1}
                onPageChange={onPageChange}
                totalPages={listInfo.totalPages}
              />
            </Container>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default HostTable;
